<div class="watermark_overlay" *ngIf="showWatermark">
  <div class="watermark_logo">
    <img src="assets/logo/watermark-logo.svg" alt="Watermark Logo" class="logo_image" />
  </div>
  <div class="watermark_text" (keydown.enter)="onTextClick()" tabindex="0" (click)="onTextClick()">
    {{ watermarkText }}
  </div>
</div>
